module.exports = new __parcel__URL__("digital-prime-fbx.85b71734.png").toString();